/**
 * 获取用户当前系统和浏览器版本
 * zhanyouwei@icloud.com
 */
import Cookies from 'js-cookie';
import { util } from '@/lib/utils';

// os: 操作系统
export const os = {};
// browser：浏览器
export const browser = {};
const ua = navigator.userAgent;
const webkit = ua.match(/Web[kK]it[/]{0,1}([\d.]+)/);
const android = ua.match(/(Android);?[\s/]+([\d.]+)?/);
  // 小米手机
const xiaomi = ua.match(/XiaoMi/);
  // 小米浏览器
const xiaomiBrowser = ua.match(/MiuiBrowser\/([\d.]+)/);
const osx = !!ua.match(/\(Macintosh; Intel /);
const ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
const iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
const webos = ua.match(/(webOS|hpwOS)[\s/]([\d.]+)/);
const touchpad = webos && ua.match(/TouchPad/);
  // UC浏览器
const uc = ua.match(/UCBrowser\/([\d.]+)/);
  // 微信
const wx = ua.match(/MicroMessenger\/([\d.]+)/);
const kindle = ua.match(/Kindle\/([\d.]+)/);
const silk = ua.match(/Silk\/([\d._]+)/);
const blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
const bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
const rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
const playbook = ua.match(/PlayBook/);
const chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
const firefox = ua.match(/Firefox\/([\d.]+)/);
const ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^?]+).*rv:([0-9.].)/);
const webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/);
const safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);
// QQ中打开
const qq = ua.match(/\sQQ/i);
const app = Cookies.get('MT_USER_INFO') !== undefined;

// Todo: clean this up with a better OS/browser seperation:
// - discern (more) between multiple browsers on android
// - decide if kindle fire in silk mode is android or not
// - Firefox on Android doesn't specify the Android version
// - possibly devide in os, device and browser hashes

if (browser.webkit === !!webkit) {
  browser.version = webkit[1];
}

if (android) {
  os.android = true;
  os.type = 'AM';
  os.version = android[2];
}
if (iphone && !ipod) {
  os.ios = true;
  os.iphone = true;
  os.type = 'IOS';
  os.version = iphone[2].replace(/_/g, '.');
}
// 小米手机
if (xiaomi) {
  os.xiaomi = true;
}
if (ipad) {
  os.ios = true;
  os.ipad = true;
  os.version = ipad[2].replace(/_/g, '.');
}
if (ipod) {
  os.ios = true;
  os.ipod = true;
  os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
}
if (webos) {
  os.webos = true;
  os.version = webos[2];
}
if (touchpad) {
  os.touchpad = true;
}
if (blackberry) {
  os.blackberry = true;
  os.version = blackberry[2];
}
if (bb10) {
  os.bb10 = true;
  os.version = bb10[2];
}
if (rimtabletos) {
  os.rimtabletos = true;
  os.version = rimtabletos[2];
}
if (playbook) {
  browser.playbook = true;
}
if (kindle) {
  os.kindle = true;
  os.version = kindle[1];
}
if (silk) {
  browser.silk = true;
  browser.version = silk[1];
}
if (!silk && os.android && ua.match(/Kindle Fire/)) {
  browser.silk = true;
}
if (chrome) {
  browser.chrome = true;
  browser.version = chrome[1];
}
if (firefox) {
  browser.firefox = true;
  browser.version = firefox[1];
}
// UC
if (uc) {
  browser.uc = true;
  browser.version = uc[1];
}
// 小米
if (os.xiaomi && xiaomiBrowser) {
  browser.xiaomiBrowser = true;
  browser.version = xiaomiBrowser[1];
}
// 微信
if (wx) {
  browser.wx = true;
  browser.version = wx[1];
}

if (ie) {
  browser.ie = true;
  browser.version = ie[1];
}
if (safari && (osx || os.ios)) {
  browser.safari = true;
  if (osx) browser.version = safari[1];
}
if (webview) {
  browser.webview = true;
}
if (qq) {
  browser.qq = true;
}
if (app) {
  const allCookies = Cookies.get();
  const fck = allCookies.MT_USER_INFO.split(',');

  const curserVersion = util.base64Decode(fck[1]);
  browser.app = true;
  browser.version = curserVersion;
}

os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) || (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
os.phone = !!(!os.tablet && !os.ipod && (android || iphone || webos || blackberry || bb10 || (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) || (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));

// export os;
// export browser;



// WEBPACK FOOTER //
// ./src/lib/ua.js